import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchUser from "@/views/用户管理/model/DZSearchUser";
import DZModelNormalUser from "../model/DZModelNormalUser";

class DZServiceNormalUser {

    m_page = new DZSearchUser(10);

    list_user: Array<DZModelNormalUser> = [];

    m_user = new DZModelNormalUser();

    net_user_list() {
        nyNetwork.net("普通用户列表", this.m_page, res => {
            this.list_user = res.list
            this.m_page.total = res.total
        })
    }

    net_zquser_list() {
        nyNetwork.net("政企用户列表", this.m_page, res => {
            this.list_user = res.list
            this.m_page.total = res.total
        })
    }

    net_operate_user(id, success: () => void) {
        nyNetwork.net('禁用启用用户', { id: id }, res => {
            success()
        })
    }

    net_add_zq_user(user, success: () => void) {
        nyNetwork.net('添加政企用户', user, res => {
            success()
        })
    }

    net_edit_zq_user(user, success: () => void) {
        nyNetwork.net('编辑政企用户', user, res => {
            success()
        })
    }

}
export default DZServiceNormalUser
